import { map, flatten } from 'lodash'
import { FetchFn } from '@wix/thunderbolt-symbols'
import { MetricsReporter } from '@wix/thunderbolt-becky-types'
import { PresetsUrls, URL, WidgetsToPresets, WidgetsToPresetToCss } from './types'

export const createFetchMemoization = (fetchFn: FetchFn) => {
	const cacheKey = `?cacheKey=${Math.floor(Math.random() * 1000)}`
	const fetchPromises: { [url: string]: Promise<Response> } = {}
	const memoizedFetch: FetchFn = (url: string) => {
		if (!fetchPromises[url]) {
			fetchPromises[url] = fetchFn(`${url}${cacheKey}`)
		}
		return fetchPromises[url]
	}
	return memoizedFetch
}

export const fetchPresets = async (
	presetsMap: WidgetsToPresets,
	memoizedFetch: FetchFn,
	metricsReporter: MetricsReporter
): Promise<WidgetsToPresetToCss> => {
	const presetsCss = await Promise.all(
		map(
			presetsMap,
			async (widgetPresets: PresetsUrls, widgetId: string) =>
				await Promise.all(
					map(widgetPresets, async (url: URL, presetId: string) => {
						const presetCss = await memoizedFetch(url)
							.then((resp: Response) => {
								if (!resp.ok) {
									throw new Error(`Failed to fetch preset: ${presetId} for widget: ${widgetId}`)
								}
								return resp.text()
							})
							.catch((e) => {
								metricsReporter.reportError(e)
								return ''
							})
						return { widgetId, presetId, presetCss: presetCss.replace('\n', '') }
					})
				)
		)
	)

	return flatten(presetsCss).reduce((acc: WidgetsToPresetToCss, { widgetId, presetId, presetCss }) => {
		acc[widgetId] = acc[widgetId] || {}
		acc[widgetId][presetId] = presetCss
		return acc
	}, {})
}
